import { render, staticRenderFns } from "./SingleEODV2.vue?vue&type=template&id=39ea1a74&scoped=true"
import script from "./SingleEODV2.vue?vue&type=script&lang=js"
export * from "./SingleEODV2.vue?vue&type=script&lang=js"
import style0 from "./SingleEODV2.vue?vue&type=style&index=0&id=39ea1a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ea1a74",
  null
  
)

export default component.exports